import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { staticDataTypeLabelQueries } from '@/services/staticDataTypeLabel/staticDataTypeLabel.queries';
import { useSearch } from '@tanstack/react-router';

export const useStaticDataTypeLabelList = () => {
  const { page, fetch, q, sort, staticDataTypeId } = useSearch({
    from: '/(app)/logs-management/static-data-type/$staticDataTypeName/',
  });
  const { data, isLoading } = useQuery({
    ...staticDataTypeLabelQueries.list({
      row: page,
      fetch: fetch,
      search: q,
      staticDataTypeId,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data ?? [], sort),
    }),
  });
  return {
    staticDataTypeLabel: data?.data || [],
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
